export const variaveisDisponiveis = [
  "apelidoFantasia",
  "nomeCompletoCliente",
  "primeiroNomeCliente",
  "documentosAVencer",
  "nomeUsuario",
  "dataAgendamento",
  "horaAgendamento",
];

export const contextosLote = [
  {
    label: "Aniversário",
    value: "aniversario",
  },
  {
    label: "Condicional - Cobrança",
    value: "condicional-cobranca",
  },
  {
    label: "Condicional - Lembrete",
    value: "condicional-lembrete",
  },
  {
    label: "Conta Receber - Cobrança",
    value: "conta-receber-cobranca",
  },
  {
    label: "Conta Receber - Lembrete",
    value: "conta-receber-lembrete",
  },
  /*   {
    label: "Clientes",
    value: "clientes",
  }, */
  {
    label: "Campanha",
    value: "campanha",
  },
];

export const contextos = [
  {
    label: "Condicional",
    value: "condicional",
  },
  {
    label: "NF-Saída",
    value: "nf-saida",
  },
  {
    label: "Orçamento",
    value: "orcamento",
  },
  {
    label: "Pedido",
    value: "pedido",
  },
  {
    label: "Agendamento (Serviço)",
    value: "agendamentoServico",
  },
  {
    label: "Lembrete Agendamento (Serviço)",
    value: "lembreteAgendamentoServico",
  },
];
